/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

(function () {
  'use strict';

  if (customElements.get('cart-drawer')) return;
  var AirX = window.AirX;
  if (!AirX || !AirX.DrawerElement) return;

  var motionOn = function () {
    return window.gsap && document.documentElement.classList.contains('motion');
  };

  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var ICON_PLUS =
    '<svg class="icon icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';

  function readStrings(root, selector, defaults) {
    var el = root.querySelector(selector);
    if (!el) return defaults;
    try {
      return Object.assign(defaults, JSON.parse(el.textContent));
    } catch (err) {
      return defaults;
    }
  }

  function ensurePendingWatch() {
    if (window.AirXPendingWatch) return window.AirXPendingWatch;

    var subscribers = new Set();
    var timer = null;
    var inflight = null;
    var pending = false;
    var known = false;

    function cartHasPending(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;
      return cart.items.some(function (item) {
        var props = item.properties || {};
        return Object.keys(props).some(function (key) {
          var value = props[key];
          return typeof value === 'string' && value.indexOf('pending://') === 0;
        });
      });
    }

    function setPending(next) {
      var was = pending;
      pending = next;
      known = true;
      subscribers.forEach(function (fn) {
        try { fn(pending); } catch (err) {  }
      });
      if (pending && !timer) {
        timer = setInterval(function () { watch.check(); }, 4000);
      }
      if (!pending && timer) {
        clearInterval(timer);
        timer = null;
      }
      if (!pending && was) {

        AirX.cart.update({}).catch(function () {});
      }
    }

    var watch = {
      get pending() { return pending; },
      subscribe: function (fn) {
        subscribers.add(fn);
        if (known) fn(pending);
      },

      check: function (cart) {
        if (cart && cart.token) {
          setPending(cartHasPending(cart));
          return Promise.resolve(pending);
        }
        if (inflight) return inflight;
        inflight = AirX.cart
          .get()
          .then(function (data) {
            inflight = null;
            setPending(cartHasPending(data));
            return pending;
          })
          .catch(function () {
            inflight = null;
            return pending;
          });
        return inflight;
      },

      seed: function (isPending) {
        if (!known) setPending(!!isPending);
      },
    };

    window.AirXPendingWatch = watch;
    return watch;
  }

  class CartDrawer extends AirX.DrawerElement {
    connectedCallback() {
      super.connectedCallback();
      this.qtyTimers = {};
      this.upsellCache = {};
      this.noteOpen = false;
      this.lastSubtotal = null;
      this.lastFsb = null;
      this.lastRender = Date.now();
      this.strings = readStrings(this, '[data-cart-drawer-strings]', {
        error: 'Something went wrong. Please try again.',
        upsellAddLabel: 'Add [title] to your collection',
      });

      this.readMoneyState();
      this.bindEvents();

      this.watch = ensurePendingWatch();
      this.watch.subscribe(this.applyPending.bind(this));
      var region = this.querySelector('[data-drawer-refresh]');
      this.watch.seed(region && region.getAttribute('data-has-pending') === 'true');
      this.checkAddons();
    }

    bindEvents() {
      var self = this;

      this.addEventListener('change', function (e) {
        var qty = e.target.closest('[data-cart-qty]');
        if (qty) { self.onQtyChange(qty); return; }
        var note = e.target.closest('[data-cart-note]');
        if (note) self.saveNote(note);
      });

      this.addEventListener('click', function (e) {

        var close = e.target.closest('[data-drawer-close]');
        if (close) { self.close(); return; }
        var remove = e.target.closest('[data-cart-remove]');
        if (remove) { self.onRemove(remove); return; }
        var noteToggle = e.target.closest('[data-note-toggle]');
        if (noteToggle) { self.toggleNote(noteToggle); return; }
        var upsell = e.target.closest('[data-upsell-add]');
        if (upsell) self.onUpsellAdd(upsell);
      });

      AirX.on('cart:updated', function (e) {
        var d = e.detail || {};

        if (d.data && d.data.token) self.checkAddons(d.data);
        if (d.sections && d.sections['cart-drawer']) {
          self.renderSection(d.sections['cart-drawer']);
        } else {
          self.refreshFromServer();
        }
        self.watch.check(d.data && d.data.token ? d.data : undefined);
        if (d.source === 'add' && !document.querySelector('main-cart')) self.open();
      });

      AirX.on('quick-add:added', function () {
        if (!document.querySelector('main-cart')) self.open();
      });
    }

    open(trigger) {
      var wasOpen = this.isOpen;
      super.open(trigger);
      if (this.isOpen && !wasOpen) {
        this.entrance();
        this.maybeLoadUpsells();

        this.checkAddons(null, Date.now() - this.lastRender > 1500);
      }
    }

    entrance() {
      if (!motionOn()) return;
      var rows = this.querySelectorAll('[data-cart-item]');
      if (!rows.length) return;
      window.gsap.fromTo(
        rows,
        { opacity: 0, x: 24 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'power3.out', stagger: 0.05, delay: 0.12, clearProps: 'opacity,transform' }
      );
    }

    renderSection(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      this.swapRefresh(doc.querySelector('[data-drawer-refresh]'));
    }

    refreshFromServer() {
      var self = this;
      AirX.fetchSection('cart-drawer')
        .then(function (doc) {
          self.swapRefresh(doc.querySelector('[data-drawer-refresh]'));
        })
        .catch(function () {});
    }

    swapRefresh(fresh) {
      var current = this.querySelector('[data-drawer-refresh]');
      if (!current || !fresh) return;
      var activeId = document.activeElement && document.activeElement.id;
      current.innerHTML = fresh.innerHTML;
      current.setAttribute('data-has-pending', fresh.getAttribute('data-has-pending') || 'false');
      this.afterRender(activeId);
    }

    afterRender(activeId) {
      this.tweenSubtotal();
      this.tweenFreeShipping();
      this.restoreNote();
      this.applyPending(this.watch ? this.watch.pending : false);
      this.maybeLoadUpsells();
      this.lastRender = Date.now();
      this.checkAddons();

      if (this.isOpen) {
        var candidate = activeId ? document.getElementById(activeId) : null;
        if (candidate && !this.contains(candidate)) candidate = null;
        AirX.trapFocus(this.panel, candidate || this.panel.querySelector('[data-drawer-close]'));
      }
    }

    readMoneyState() {
      var sub = this.querySelector('[data-cart-subtotal]');
      this.lastSubtotal = sub ? parseInt(sub.getAttribute('data-cents'), 10) : null;
      var fill = this.querySelector('[data-fsb-fill]');
      this.lastFsb = fill ? parseFloat(fill.getAttribute('data-progress')) : null;
    }

    tweenSubtotal() {
      var el = this.querySelector('[data-cart-subtotal]');
      if (!el) { this.lastSubtotal = null; return; }
      var next = parseInt(el.getAttribute('data-cents'), 10) || 0;
      var prev = this.lastSubtotal;
      this.lastSubtotal = next;
      if (prev == null || prev === next || !motionOn()) return;
      var obj = { v: prev };
      window.gsap.to(obj, {
        v: next,
        duration: 0.6,
        ease: 'power2.out',
        onUpdate: function () { el.textContent = AirX.formatMoney(Math.round(obj.v)); },
        onComplete: function () { el.textContent = AirX.formatMoney(next); },
      });
    }

    tweenFreeShipping() {
      var fill = this.querySelector('[data-fsb-fill]');
      if (!fill) { this.lastFsb = null; return; }
      var next = parseFloat(fill.getAttribute('data-progress')) || 0;
      var prev = this.lastFsb;
      this.lastFsb = next;
      if (prev == null || prev === next || !motionOn()) return;
      fill.style.transition = 'none';
      window.gsap.fromTo(
        fill,
        { width: prev + '%' },
        {
          width: next + '%',
          duration: 0.7,
          ease: 'power3.out',
          onComplete: function () { fill.style.transition = ''; },
        }
      );
    }

    applyPending(isPending) {
      this.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
        btn.disabled = isPending;
        btn.setAttribute('aria-disabled', String(isPending));
      });
      var banner = this.querySelector('[data-pending-banner]');
      if (banner) banner.hidden = !isPending;
    }

    checkAddons(cart, verify) {
      if (!AirX.cart.syncAddons || document.querySelector('main-cart')) return;
      if (!cart) {
        var state = AirX.cart.addonState(this);
        if (state === 'none' || (state === 'ok' && !verify)) return;
      }
      AirX.cart.syncAddons(cart || undefined).catch(function () {});
    }

    lineRequest(row, key, qty) {
      var updates = AirX.cart.addonUpdates ? AirX.cart.addonUpdates(row, key, qty) : null;
      if (updates) return AirX.cart.update({ updates: updates });
      return AirX.cart.change({ id: key, quantity: qty });
    }

    onQtyChange(input) {
      var key = input.getAttribute('data-line-key');
      if (!key) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      var row = input.closest('[data-cart-item]');

      clearTimeout(this.qtyTimers[key]);
      var self = this;
      this.qtyTimers[key] = setTimeout(function () {

        if (row) row.classList.add('is-updating');
        self.lineRequest(row, key, qty).catch(function (err) {

          input.value = input.getAttribute('value');
          if (row) row.classList.remove('is-updating');
          self.showError(err && err.message);
        });
      }, 300);
    }

    onRemove(button) {
      var row = button.closest('[data-cart-item]');
      var key = row && row.getAttribute('data-line-key');
      if (!key) return;
      button.disabled = true;
      var self = this;
      var commit = function () {
        self.lineRequest(row, key, 0).catch(function (err) {
          button.disabled = false;
          if (window.gsap) window.gsap.set(row, { clearProps: 'all' });
          self.showError(err && err.message);
        });
      };
      if (motionOn() && row) {
        window.gsap.set(row, { overflow: 'hidden' });
        window.gsap.to(row, {
          height: 0,
          opacity: 0,
          paddingTop: 0,
          paddingBottom: 0,
          duration: 0.35,
          ease: 'power2.in',
          onComplete: commit,
        });
      } else {
        commit();
      }
    }

    toggleNote(button) {
      var wrap = this.querySelector('[data-cart-note-wrap], #CartDrawer-NoteWrap');
      if (!wrap) return;
      var opening = wrap.hidden;
      wrap.hidden = !opening;
      this.noteOpen = opening;
      button.setAttribute('aria-expanded', String(opening));
      if (opening) {
        var textarea = wrap.querySelector('textarea');
        if (textarea) textarea.focus();
      }
    }

    restoreNote() {
      if (!this.noteOpen) return;
      var wrap = this.querySelector('#CartDrawer-NoteWrap');
      var button = this.querySelector('[data-note-toggle]');
      if (wrap) wrap.hidden = false;
      if (button) button.setAttribute('aria-expanded', 'true');
    }

    saveNote(textarea) {
      var self = this;
      AirX.cart.update({ note: textarea.value }).catch(function (err) {
        self.showError(err && err.message);
      });
    }

    showError(message) {
      var el = this.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = message || this.strings.error;
      el.hidden = false;
      clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(function () { el.hidden = true; }, 4500);
    }

    maybeLoadUpsells() {
      var wrap = this.querySelector('[data-cart-upsells]');
      if (!wrap || !this.isOpen) return;
      var productId = wrap.getAttribute('data-product-id');
      if (!productId) { wrap.hidden = true; return; }
      var self = this;
      if (this.upsellCache[productId]) {
        this.renderUpsells(wrap, this.upsellCache[productId]);
        return;
      }
      var base = (window.AirXRoutes && window.AirXRoutes.product_recommendations_url) || '/recommendations/products';
      fetch(base + '.json?product_id=' + encodeURIComponent(productId) + '&limit=8&intent=related')
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (data) {
          self.upsellCache[productId] = (data && data.products) || [];
          self.renderUpsells(wrap, self.upsellCache[productId]);
        })
        .catch(function () { wrap.hidden = true; });
    }

    renderUpsells(wrap, products) {
      var inCart = {};
      this.querySelectorAll('[data-cart-item]').forEach(function (row) {
        inCart[row.getAttribute('data-product-id')] = true;
      });
      var self = this;
      var picks = (products || [])
        .filter(function (p) {
          if (!p || inCart[String(p.id)]) return false;
          if (p.handle === 'custom-canvas' || p.handle === 'canvas-coating') return false;
          if (!p.available) return false;
          return p.variants && p.variants.length;
        })
        .slice(0, 4);
      var rail = wrap.querySelector('[data-upsell-rail]');
      if (!picks.length || !rail) { wrap.hidden = true; return; }
      rail.innerHTML = picks.map(function (p) { return self.upsellCardHtml(p); }).join('');
      wrap.hidden = false;
      if (motionOn()) {
        window.gsap.fromTo(
          rail.children,
          { opacity: 0, y: 12 },
          { opacity: 1, y: 0, duration: 0.4, ease: 'power3.out', stagger: 0.06, clearProps: 'opacity,transform' }
        );
      }
    }

    upsellCardHtml(product) {
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { variant = product.variants[i]; break; }
      }
      if (!variant) variant = product.variants[0];

      var image = '';
      if (product.featured_image) {
        image = '<img src="' + esc(this.sizedImage(product.featured_image, 240)) + '" alt="" width="112" height="112" loading="lazy">';
      }

      var price;
      if (product.compare_at_price && product.compare_at_price > product.price) {
        price =
          '<span class="price__sale">' + esc(AirX.formatMoney(product.price)) + '</span>' +
          '<s class="price__compare">' + esc(AirX.formatMoney(product.compare_at_price)) + '</s>';
      } else {
        price = '<span class="price__regular">' + esc(AirX.formatMoney(product.price)) + '</span>';
      }

      var label = String(this.strings.upsellAddLabel || 'Add [title]').replace('[title]', product.title);

      return (
        '<article class="cart-upsell-card">' +
        '<a href="' + esc(product.url) + '" class="cart-upsell-card__thumb artwork-tile" tabindex="-1" aria-hidden="true">' + image + '</a>' +
        '<div class="cart-upsell-card__info">' +
        '<a class="cart-upsell-card__title" href="' + esc(product.url) + '">' + esc(product.title) + '</a>' +
        '<span class="price cart-upsell-card__price">' + price + '</span>' +
        '</div>' +
        '<button type="button" class="cart-upsell-card__add" data-upsell-add data-variant-id="' + Number(variant.id) + '" aria-label="' + esc(label) + '"' +
        (variant.available ? '' : ' disabled') +
        '>' + ICON_PLUS + '</button>' +
        '</article>'
      );
    }

    onUpsellAdd(button) {
      var variantId = Number(button.getAttribute('data-variant-id'));
      if (!variantId) return;
      var self = this;
      button.classList.add('is-loading');
      button.disabled = true;
      AirX.cart.add({ id: variantId, quantity: 1 }).catch(function (err) {
        button.classList.remove('is-loading');
        button.disabled = false;
        self.showError(err && err.message);
      });

    }

    sizedImage(src, width) {
      try {
        var u = new URL(src, window.location.origin);
        u.searchParams.set('width', String(width));
        return u.href;
      } catch (err) {
        return src;
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);
})();
